<template>
  <ion-content>
    <ion-list>
      <ion-list-header>{{ name }}</ion-list-header>
      <ion-item :id="'option-'+itemIndex" button detail="false" v-for="(listValue, itemIndex) in listValues" :key="itemIndex" @click="doAction(itemIndex)">{{ listValue }}</ion-item>
      <ion-item lines="none" detail="false" button @click="dismissPopover">{{ $t('buttons.close') }}</ion-item>
    </ion-list>
  </ion-content>
</template>

<script>
import { IonContent, IonList, IonListHeader, IonItem, popoverController } from '@ionic/vue';
import { defineComponent } from 'vue';
import { Browser } from '@capacitor/browser';

export default defineComponent ({
  name: 'PopoverView',
  props: {
    name: String,
    type: String,
    data: Object
  },
  components: { IonContent, IonList, IonListHeader, IonItem },
  setup() {
    const dismissPopover = () => {
      popoverController.dismiss();
    };
    // console.log(this.data);
    
    return {dismissPopover }
  },
  data(){
    return {
      listValues: []
    }
  },
  mounted(){
    //var listValues = [];
    if(this.type=="public-story"){
      //listValues = ['Report Post', 'Hide Post', 'Request To Add To Story'];
      this.listValues = [this.$t("popover.reportpost"), this.$t("popover.hidepost"), this.$t("popover.requesttoadd")];
    }else if(this.type=="owner-story"){
      this.listValues = ['Pin Post', this.$t("popover.editpost"), this.$t("popover.deletepost"), this.$t("popover.editstoryname"), this.$t("popover.editprivacy"), this.$t("popover.editcanadd")];
      if(this.data.pinnedPost){
        this.listValues[0] = 'Unpin Post';
      }
    }else if(this.type=="contrib-story"){
      //listValues = ['Report Post'];
      this.listValues = [this.$t("popover.reportpost")];
    //}else if(this.type=="likes-image"){
    //  listValues = ['Like It', 'Love It', 'Great Shot', 'Cool', 'Cute', 'Wow'];
    }else if(this.type=="comment"){
      //listValues = ['Report Comment'];
      this.listValues = [this.$t("popover.reportcomment")];
    }else if(this.type=="my-comment"){
      //listValues = ['Edit Comment', 'Delete Comment'];
      this.listValues = [this.$t("popover.editcomment"), this.$t("popover.deletecomment")];
    }else if(this.type=="my-comment-post"){
      //listValues = ['Report Comment', 'Delete Comment'];
      this.listValues = [this.$t("popover.reportcomment"), this.$t("popover.deletecomment")];
    }else if(this.type=="share-post"){
      //listValues = ['Share', 'Share with Comment', 'Share To My Story', 'Share Other Places'];
      this.listValues = [this.$t("popover.share"), this.$t("popover.sharecomment"), this.$t("popover.sharestory"), this.$t("popover.shareother")];
    }else if(this.type=="message-thread-options"){
      //listValues = ['Share', 'Share with Comment', 'Share To My Story', 'Share Other Places'];
      this.listValues = [this.$t("popover.leavegroup")];
    }else if(this.type=="message-thread-options-admin"){
      //listValues = ['Share', 'Share with Comment', 'Share To My Story', 'Share Other Places'];
      this.listValues = [this.$t("popover.managegroup")];
    }else if(this.type=="profile-websites"){
      for(var i=0; i<this.data.length; i++){
        this.listValues.push(this.data[i]['name']);
      }
    }else if(this.type=="manage-group"){
      //listValues = ['Report Comment', 'Delete Comment'];
      this.listValues = ['Edit Details', 'Manage Members', 'Manage Files'];
    }else if(this.type=="manage-group-owner"){
      //listValues = ['Report Comment', 'Delete Comment'];
      this.listValues = ['Edit Details', 'Manage Members', 'Manage Files', 'Delete Group'];
    }else if(this.type=="manage-group-member"){
      if(this.data.admin==1){
        this.listValues = ['Make Normal Member', 'View Answers', 'Remove', 'Block User'];
      }else{
        this.listValues = ['Make Admin', 'View Answers',  'Remove', 'Block User'];
      }
    }else if(this.type=="manage-group-request"){
      this.listValues = ['Approve', 'Deny', 'Deny & Block'];
    }else if(this.type=="manage-group-request-a"){
      this.listValues = ['Approve', 'View Answers', 'Deny', 'Block User'];
    }else if(this.type=="manage-group-files"){
      this.listValues = ['View/Download', 'Edit Description', 'Remove'];
    }else if(this.type=="group-story-owner"){
      this.listValues = [this.$t("popover.editpost"), this.$t("popover.deletepost"), this.$t("popover.editstoryname")];
    }else if(this.type=="group-story-admin-owner"){
      this.listValues = ['Pin Post', this.$t("popover.editpost"), this.$t("popover.deletepost"), this.$t("popover.editstoryname")];
      if(this.data.pinnedPost){
        this.listValues[0] = 'Unpin Post';
      }
    }else if(this.type=="group-story-admin-other"){
      this.listValues = ['Pin Post', this.$t("popover.deletepost"), this.$t("popover.reportpost"), this.$t("popover.hidepost")];
      if(this.data.pinnedPost){
        this.listValues[0] = 'Unpin Post';
      }
    }
  },
  methods: {
    async doAction(itemIndex){
      //console.log(itemIndex, 'itemIndex');
      var role = 'none';
      if(this.type=="public-story"){
        if(itemIndex==0){
          role = "report-post";
        }else if(itemIndex==1){
          role = "hide-post";
        }else if(itemIndex==2){
          role = "request-add";
        }
        popoverController.dismiss(null, role);
      }else if(this.type=="owner-story"){
        if(itemIndex==0){
          role = "pin-post";
        }else if(itemIndex==1){
          role = "edit-post";
        }else if(itemIndex==2){
          role = "delete-post";
        }else if(itemIndex==3){
          role = "edit-storyname";
        }else if(itemIndex==4){
          role = "edit-privacy";
        }else if(itemIndex==5){
          role = "edit-canadd";
        }
        popoverController.dismiss(null, role);
      }else if(this.type=="contrib-story"){
        if(itemIndex==0){
          role = "report-post";
        }
        popoverController.dismiss(null, role);
      }else if(this.type=="profile-websites"){
        for(var i=0; i<this.data.length; i++){
          if(itemIndex==i){
            //console.log(this.data[i]['url']);
            await Browser.open({ url: this.data[i]['url'] }); 
            //window.open(this.data[i]['url'], '_blank');
            popoverController.dismiss();
          }
        }
      }else if(this.type=="comment"){
        if(itemIndex==0){
          role = "report-comment";
        }
        popoverController.dismiss(null, role);
      }else if(this.type=="my-comment"){
        if(itemIndex==0){
          role = "edit-comment";
        }else if(itemIndex==1){
          role = "delete-comment";
        }
        popoverController.dismiss(null, role);
      }else if(this.type=="my-comment-post"){
        if(itemIndex==0){
          role = "report-comment";
        }else if(itemIndex==1){
          role = "delete-comment";
        }
        popoverController.dismiss(null, role);
      }else if(this.type=="share-post"){
        if(itemIndex==0){
          role = "share";
        }else if(itemIndex==1){
          role = "share-comment";
        }else if(itemIndex==2){
          role = "share-my-story";
        }else if(itemIndex==3){
          role = "share-other-places";
        }
        popoverController.dismiss(null, role);
      }else if(this.type=="message-thread-options"){
        if(itemIndex==0){
          role = "leave-group";
        }
        popoverController.dismiss(null, role);
      }else if(this.type=="message-thread-options-admin"){
        if(itemIndex==0){
          role = "edit-group";
        }
        popoverController.dismiss(null, role);
      }else if(this.type=="manage-group"){
        if(itemIndex==0){
          role = "edit";
        }else if(itemIndex==1){
          role = "members";
        }else if(itemIndex==2){
          role = "files";
        }
        
        popoverController.dismiss(null, role);
      }else if(this.type=="manage-group-owner"){
        if(itemIndex==0){
          role = "edit";
        }else if(itemIndex==1){
          role = "members";
        }else if(itemIndex==2){
          role = "files";
        }else if(itemIndex==3){
          role = "delete";
        }
        
        popoverController.dismiss(null, role);
      }else if(this.type=="manage-group-member"){
        if(itemIndex==0){
          role = "admin";
        }else if(itemIndex==1){
          role = "answers";
        }else if(itemIndex==2){
          role = "remove";
        }else if(itemIndex==3){
          role = "block";
        }
        
        popoverController.dismiss(null, role);
      }else if(this.type=="manage-group-request"){
        if(itemIndex==0){
          role = "add";
        }else if(itemIndex==1){
          role = "deny";
        }else if(itemIndex==2){
          role = "denyblock";
        }
        
        popoverController.dismiss(null, role);
      }else if(this.type=="manage-group-request-a"){
        if(itemIndex==0){
          role = "add";
        }else if(itemIndex==1){
          role = "answers";
        }else if(itemIndex==2){
          role = "deny";
        }else if(itemIndex==3){
          role = "denyblock";
        }
        
        popoverController.dismiss(null, role);
      }else if(this.type=="manage-group-files"){
        if(itemIndex==0){
          role = "view";
        }else if(itemIndex==1){
          role = "edit";
        }else if(itemIndex==2){
          role = "remove";
        }
        
        popoverController.dismiss(null, role);
      }else if(this.type=="group-story-owner"){
        if(itemIndex==0){
          role = "edit-post";
        }else if(itemIndex==1){
          role = "delete-post";
        }else if(itemIndex==2){
          role = "edit-storyname";
        }
        
        popoverController.dismiss(null, role);
      }else if(this.type=="group-story-admin-owner"){
        if(itemIndex==0){
          role = "pin-post";
        }else if(itemIndex==1){
          role = "edit-post";
        }else if(itemIndex==2){
          role = "delete-post";
        }else if(itemIndex==3){
          role = "edit-storyname";
        }
        
        popoverController.dismiss(null, role);
      }else if(this.type=="group-story-admin-other"){
        if(itemIndex==0){
          role = "pin-post";
        }else if(itemIndex==1){
          role = "delete-post";
        }else if(itemIndex==2){
          role = "report-post";
        }else if(itemIndex==3){
          role = "hide-post";
        }
        
        popoverController.dismiss(null, role);
      }

    },
  }
});
</script>
